import { getConfig } from '@superbet-group/web.lib.config';
import { Country } from '@superbet-group/web.types';
import { TimeFilter } from '@shared/timeFilter/types';

const englishTimeFilters = {
    Live: 'live',
    All: 'all',
    Today: 'today',
    Upcoming: 'upcoming',
    Sunday: 'sunday',
    Monday: 'monday',
    Tuesday: 'tuesday',
    Wednesday: 'wednesday',
    Thursday: 'thursday',
    Friday: 'friday',
    Saturday: 'saturday',
};

const CountryTimeFilterSlug: Record<Country, Record<TimeFilter, string>> = {
    [Country.Ro]: {
        Live: 'live',
        All: 'toate',
        Today: 'astazi',
        Upcoming: 'urmatoare',
        Sunday: 'duminica',
        Monday: 'luni',
        Tuesday: 'marti',
        Wednesday: 'miercuri',
        Thursday: 'joi',
        Friday: 'vineri',
        Saturday: 'sambata',
    },
    [Country.RoNapoleon]: {
        Live: 'live',
        All: 'toate',
        Today: 'astazi',
        Upcoming: 'urmatoare',
        Sunday: 'duminica',
        Monday: 'luni',
        Tuesday: 'marti',
        Wednesday: 'miercuri',
        Thursday: 'joi',
        Friday: 'vineri',
        Saturday: 'sambata',
    },
    [Country.Pl]: {
        Live: 'live',
        All: 'wszystko',
        Today: 'dzisiaj',
        Upcoming: 'nadchodzace',
        Sunday: 'niedziela',
        Monday: 'poniedzialek',
        Tuesday: 'wtorek',
        Wednesday: 'sroda',
        Thursday: 'czwartek',
        Friday: 'piatek',
        Saturday: 'sobota',
    },
    [Country.Rs]: {
        Live: 'uzivo',
        All: 'sve',
        Today: 'danas',
        Upcoming: 'predstojeci',
        Sunday: 'nedelja',
        Monday: 'ponedeljak',
        Tuesday: 'utorak',
        Wednesday: 'sreda',
        Thursday: 'cetvrtak',
        Friday: 'petak',
        Saturday: 'subota',
    },
    [Country.Be]: englishTimeFilters,
    [Country.Com]: englishTimeFilters,
    [Country.Bg]: englishTimeFilters,
    [Country.Br]: {
        Live: 'ao-vivo',
        All: 'todos',
        Today: 'hoje',
        Upcoming: 'proximos',
        Sunday: 'domingo',
        Monday: 'segunda-feira',
        Tuesday: 'terca-feira',
        Wednesday: 'quarta-feira',
        Thursday: 'quinta-feira',
        Friday: 'sexta-feira',
        Saturday: 'sabado',
    },
    [Country.BrSocial]: {
        Live: 'ao-vivo',
        All: 'todos',
        Today: 'hoje',
        Upcoming: 'proximos',
        Sunday: 'domingo',
        Monday: 'segunda-feira',
        Tuesday: 'terca-feira',
        Wednesday: 'quarta-feira',
        Thursday: 'quinta-feira',
        Friday: 'sexta-feira',
        Saturday: 'sabado',
    },
};
export const TimeFilterSlug = CountryTimeFilterSlug[getConfig().countrySpecific.country];
